"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var alignSelfMap = {
    end: 'flex-end',
    start: 'flex-start',
    center: 'center',
    stretch: 'stretch',
};
exports.default = (function (_a) {
    var alignSelf = _a.alignSelf;
    return (alignSelf && alignSelf in alignSelfMap)
        && "align-self: " + alignSelfMap[alignSelf] + ";";
});
